import { TuiButtonModule } from '@taiga-ui/core';
import { Maybe } from '@iss/libs/graphql';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

import { IconComponent } from '@iss/core/icon';

@Component({
  selector: 'wo-download-button',
  templateUrl: './download-button.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    IconComponent,
    TuiButtonModule,
  ],
})
export class DownloadButtonComponent {
  @Input() public processing: Maybe<boolean>;
  @Input() public appearance: 'outline' | 'primary' = 'outline';
  @Output() public readonly download = new EventEmitter<void>();
}
